export default __webpack_public_path__ + "static/char-thumb-06-e8afb5eab4ce714cf759e46d4413288b.png";